/**
 * Prototype-only affordances.
 *
 * The CLIENT VIEW | STAFF VIEW switcher exists purely so the product can be
 * built and tested from both sides. It must never appear on the published
 * site, so rather than relying on a flag being remembered before launch, it is
 * only ever shown while working inside the builder (or locally).
 *
 * It is also suppressed outright on a client project link — a client must have
 * no route from their project into the staff area.
 */

const BUILDER_HOSTS = ['localhost', '127.0.0.1']

function inBuilder(): boolean {
  if (typeof window === 'undefined') return false
  const { hostname } = window.location
  if (BUILDER_HOSTS.includes(hostname)) return true
  // The Magic Patterns editor preview. Published sites are served from other
  // domains (e.g. magicpatterns.app or a custom domain) and never match.
  return hostname === 'magicpatterns.com' || hostname.endsWith('.magicpatterns.com')
}

function onClientLink(): boolean {
  if (typeof window === 'undefined') return false
  return window.location.pathname.startsWith('/project/')
}

/** True only while building/testing — never on the live client experience. */
export const PROTOTYPE_MODE = inBuilder() && !onClientLink()
